@if (showLoader) {
<div class="absolute w-full h-full loader-background top-0 left-0 flex items-center justify-center">
    <vw-loader></vw-loader>
</div>
}